export const apiKey =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51GzUa4Gf5288P3kzWi4zUneWSdhyEj1wB1K5VMPoIx87u7BfzLSfkd52O45UQ2VHbh5dvW4e9MtsLwjJdiUPncNy00o7tnvaLS'
    : 'pk_test_51GzUa4Gf5288P3kz5gRphizinpW1zEDNRC3Q8iM0ISDe3yvUjaR8pqweXmkeUKeUkLhNjieF96AQM6Vz80vtWcce00HZI8VSRV'
